import React, { useMemo } from 'react';
import { v4 as guid } from 'uuid';

import './styles.scss';

interface Props {
    align?: 'left' | 'center' | 'right';
    errors?: string[];
}

export const ErrorMessage = ({ align = 'left', errors = [] }: Props) => {
    const alignmentClassName = useMemo(() => {
        switch (align) {
            case 'center':
                return 'form-error-message--align-center';
            case 'right':
                return 'form-error-message--align-right';
            case 'left':
            default:
                return 'form-error-message--align-left';
        }
    }, [align]);

    if (!errors.length) {
        return null;
    }

    return (
        <div>
            {errors.map((error) => (
                <p key={guid()} className={`form-error-message ${alignmentClassName}`}>
                    {error}
                </p>
            ))}
        </div>
    );
};
